
import { defineComponent } from 'vue'
import VisitorCard from '@/components/VisitorCard.vue'
import HotTagsCard from '@/components/HotTagsCard.vue'
// const HotTagsCard = defineAsyncComponent(()=>import('@/components/HotTagsCard.vue'))
import FriendsCard from './FriendsCard.vue'
import FinancialSupportCard from '@/components/FinancialSupportCard.vue'

export default defineComponent({
  components: {
    VisitorCard,
    FinancialSupportCard,
    FriendsCard,
    HotTagsCard,
  },
  setup() {
    return {}
  },
})
